export default __webpack_public_path__ + "static/media/DR-photo.e3e26da8.png";